/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckCartRequest } from '../../models/check-cart-request';
import { CheckCartResult } from '../../models/check-cart-result';

export interface PostCheckcart$Params {
  body?: CheckCartRequest;
}

export function postCheckcart(
  http: HttpClient,
  rootUrl: string,
  params?: PostCheckcart$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<CheckCartResult>> {
  const rb = new RequestBuilder(rootUrl, postCheckcart.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckCartResult>;
    }),
  );
}

postCheckcart.PATH = '/Orders/checkCart';
